import { createContext, useContext } from 'react';

export const TelephonyContext = createContext({
    expandCloudPhone: () => {},
    noteOutboundAttempt: () => {},
    pendingOutbound: null,
    callsRefreshKey: 0,
    minimizeDialer: () => {},
    expandDialer: () => {},
    activeCall: null,
    isDialerOpen: false,
    isMinimized: false,
});

export const useTelephony = () => useContext(TelephonyContext);
